<div class="loader ng-scope" *ngIf="isLoading"></div>
